import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

// Create the context
const TakeOffContext = createContext();

// Custom hook for easy context usage
export const useTakeOffs = () => useContext(TakeOffContext);

// Provider component
export const TakeOffProvider = ({ children }) => {
  const [takeOffs, setTakeOffs] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch all takeoffs
  const getAllTakeOffs = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        'https://api.ttfconstruction.com/takeOff/readAll.php'
      );

      if (response.data.success) {
        console.log('✅ Takeoffs retrieved successfully:', response.data.takeoffs);
        setTakeOffs(response.data.takeoffs);
      } else {
        console.error('❌ Failed to fetch takeoffs:', response.data.message);
      }
    } catch (error) {
      console.error('❌ Error fetching takeoffs:', error.message);
    } finally {
      setLoading(false);
    }
  };

  // Submit a new takeoff
  const submitNewTakeoff = async (takeoffData) => {
    try {
      const response = await axios.post(
        'https://api.ttfconstruction.com/takeOff/create.php',
        takeoffData,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data.success) {
        console.log('✅', response.data.message);
        // Refetch updated list
        await getAllTakeOffs();
        return response.data;
      } else {
        console.error('❌', response.data.message);
        return response.data;
      }
    } catch (error) {
      console.error('❌', error.message);
      return { success: false, message: error.message };
    }
  };

  // Fetch takeoffs on mount
  useEffect(() => {
    getAllTakeOffs();
  }, []);

  return (
    <TakeOffContext.Provider value={{ takeOffs, loading, getAllTakeOffs, submitNewTakeoff }}>
      {children}
    </TakeOffContext.Provider>
  );
};
